import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { Image } from "services/cms/models/image";

export type FocalPoint = "bottom" | "center" | "top";

export interface ResolvedImage {
    alt: string;
    captionText?: string;
    codename: string;
    credit?: string;
    focalPoint: FocalPoint;
    height?: number;
    src: string;
    type: ContentTypeCodenames.Image;
    width?: number;
    link?: string;
    linkTarget?: string;
}

const imageResolver = (data: Image): ResolvedImage => {
    const alt = data?.elements?.alt?.value;
    const asset = data?.elements?.asset?.value[0];
    const assetUrl = data?.elements?.assetLink?.value;
    const captionText = data?.elements?.captionText?.value;
    const credit = data?.elements?.credit?.value;
    const link = data?.elements?.link?.value;
    const linkTarget = data?.elements?.openLink?.value[0];

    const focalPoint = (data?.elements?.focalPoint?.value[0]?.name as FocalPoint) ?? "center";
    const { description, height, width } = asset ?? {};

    const image: ResolvedImage = {
        alt: alt || description || "",
        codename: data?.system?.codename,
        focalPoint,
        src: assetUrl || asset?.url,
        type: ContentTypeCodenames.Image,
    };

    if (captionText) {
        image.captionText = captionText;
    }

    if (credit) {
        image.credit = credit;
    }

    if (height) {
        image.height = height;
    }

    if (width) {
        image.width = width;
    }

    if (link) {
        image.link = link;
        image.linkTarget = linkTarget
            ? linkTarget.codename === "new_page"
                ? "_blank"
                : ""
            : "_blank";
    }

    return image;
};

export default imageResolver;
